import lightGallery from '../vendor/lightgallery/js/lightgallery';
import '../vendor/lightgallery/js/lg-video';

const $galleryBox = document.querySelectorAll( '.js-lightgallery' );

[ ...$galleryBox ].forEach( ( $gallery ) => {
  lightGallery( $gallery, { selector: 'a' } );
} );
